export const selectMasterLabel = (state) => state.masterLabel.masterLabelData;